var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"mainPhoto",staticClass:"slider__mainPhoto",class:_vm.zoomStateClass,style:(_vm.sizeZoomStyle),attrs:{"src":_vm.mainPhoto,"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }